import { apiClass } from '@/common/class/api.class'
import { ENDPOINTS } from '@/common/const/endpoints.const'
import { RESPONSE_STATUS } from '@/common/const/response.const'
import { PAYMENT_METHOD_TYPE } from '@/common/const/payment.const'
import { BLIK0_SUPPORTED_BANKS } from '@/common/const/blik.const'

const state = {
  loading: false,
  paymentStatus: null,
  systemConfiguration: BLIK0_SUPPORTED_BANKS
}

const mutations = {
  SET_BLIK_LOADING (state, value) {
    state.loading = value
  },
  SET_BLIK_PAYMENT_STATUS (state, value) {
    state.paymentStatus = value
  },
  SET_BLIK_SYSTEM_CONFIGURATION (state, data) {
    state.systemConfiguration = data
  }
}

const actions = {
  getBlikSystemConfiguration ({ commit }) {
    commit('SET_BLIK_LOADING', true)
    return apiClass.get(ENDPOINTS.blik.systemConfiguration)
      .then(response => {
        if (response.body && response.body.recurringBlikEnabledBanks) {
          commit('SET_BLIK_SYSTEM_CONFIGURATION', response.body.recurringBlikEnabledBanks)
        }
        return Promise.resolve()
      })
      .catch(error => {
        return Promise.reject(error)
      })
      .finally(() => {
        commit('SET_BLIK_LOADING', false)
      })
  },
  verifyBlik ({ commit }, data) {
    commit('SET_BLIK_LOADING', true)
    return apiClass.post(ENDPOINTS.blik.add, data)
      .then(response => {
        if (response.body && response.body.status === RESPONSE_STATUS.ok) {
          return Promise.resolve(response.body)
        }
        return Promise.reject(response.body.status)
      })
      .catch(error => {
        return Promise.reject(error)
      })
      .finally(() => {
        commit('SET_BLIK_LOADING', false)
      })
  },
  deleteBlik ({ commit }) {
    commit('SET_BLIK_LOADING', true)
    const url = ENDPOINTS.user.deletePaymentMethod + '?type=' + PAYMENT_METHOD_TYPE.blikRecurring
    return apiClass.delete(url)
      .then(response => {
        if (response.body && response.body.status === RESPONSE_STATUS.ok) {
          return Promise.resolve()
        }
        return Promise.reject(response.body.status)
      })
      .catch(error => {
        return Promise.reject(error)
      })
      .finally(() => {
        commit('SET_BLIK_LOADING', false)
      })
  }
}

const getters = {}

export default {
  state,
  mutations,
  actions,
  getters
}
